// extracted by mini-css-extract-plugin
export default {"header":"Question_header__coarD","count":"Question_count__M+Oan"};